import axios from 'axios';
import * as types from './StaticEditor.types';
import * as selectors from './StaticEditor.selectors';
import { showNotification } from './../../utils';
import * as loginActions from './../Login/Login.actions';
import * as loginSelectors from './../Login/Login.selectors';

const apiUrl = process.env.REACT_APP_API_URL;

export const fetchStaticTemplate = (id) => (dispatch) => {
    dispatch({ type: types.FETCH_STATIC_TEMPLATE, payload: null });
    axios.get(apiUrl + '/uthealth-static-templates/' + id,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.FETCH_STATIC_TEMPLATE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.FETCH_STATIC_TEMPLATE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const addToCart = (orderType = 1, history, type = 1) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const templateCode = selectors.getTemplateCode(getState());
    const quantity = selectors.getQuantity(getState());
    const printingOption = selectors.getPrintingOption(getState());
    const language = selectors.getLanguage(getState());
    const orientation = selectors.getOrientation(getState());
    const materialType = selectors.getMaterialType(getState());
    const size = selectors.getSize(getState());
    const type = selectors.getType(getState());
    const action = selectors.getAction(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('orderType', orderType);
    formData.append('productType', 2);
    formData.append('quantity', quantity);
    formData.append('printingOption', printingOption);
    formData.append('language', language);
    formData.append('orientation', orientation);
    formData.append('materialType', materialType);
    formData.append('size', size);
    formData.append('type', type);
    formData.append('templateCode', templateCode);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    formData.append('action', action);
    formData.append('type', type);
    if (action === 'edit') {
        formData.append('editId', localStorage.getItem('id'));
    }

    dispatch({ type: types.ADD_TO_CART, payload: type });
    axios.post(apiUrl + '/uthealth-shopping-cart-items', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.ADD_TO_CART_SUCCESS, payload: response.data });
            
            if (parseInt(type) === 1) {
                showNotification('Success', 'The item was added to your cart', 'success');
            } else if (parseInt(type) === 2) {
                showNotification('Success', 'The item has been saved into your shopping cart for future edit', 'success', 6000);
            }
            history.push('/shopping-cart');
        })
        .catch((error) => {
            dispatch({ type: types.ADD_TO_CART_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const loadVariables = () => (dispatch, getState) => {
    if (localStorage.getItem('variables') != null) {
        const productType = localStorage.getItem('productType');
        const quantity = localStorage.getItem('quantity');
        const variables = JSON.parse(localStorage.getItem('variables'));

        if (parseInt(productType) === 2) {    // Forms
            dispatch(setQuantity(quantity));
            dispatch(setPrintingOption(variables.printingOption));
        }
    }
}

export const addFavorite = (history) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());
    const templateCode = selectors.getTemplateCode(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('productType', 2);
    formData.append('templateCode', templateCode);
    formData.append('pathname', history.location.pathname);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.ADD_FAVORITE, payload: null });
    axios.post(apiUrl + '/uthealth-favorite/add-favorite', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.ADD_FAVORITE_SUCCESS, payload: response.data });

            if (parseInt(response.data.type) === 1) {
                showNotification('Success', 'The item has been added to your Favorites', 'success');
            } else {
                showNotification('Success', 'The item has been removed from your Favorites', 'success');
            }
        })
        .catch((error) => {
            dispatch({ type: types.ADD_FAVORITE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const checkFavorite = (templateCode) => (dispatch, getState) => {
    const user = loginSelectors.getUser(getState());
    const cxmlData = loginSelectors.getCxmlData(getState());

    var formData = new FormData();
    formData.append('userId', user.id);
    formData.append('productType', 2);
    formData.append('templateCode', templateCode);

    formData.append('cxml_id', cxmlData.id);
    formData.append('cxml_buyer_cookie', cxmlData.buyer_cookie);
    formData.append('cxml_browser_form_post', cxmlData.browser_form_post);
    formData.append('cxml_supplier_domain', cxmlData.supplier_domain);
    formData.append('cxml_supplier_id', cxmlData.supplier_id);
    formData.append('cxml_buyer_domain', cxmlData.buyer_domain);
    formData.append('cxml_buyer_id', cxmlData.buyer_id);

    dispatch({ type: types.CHECK_FAVORITE, payload: null });
    axios.post(apiUrl + '/uthealth-favorite/check-favorite', formData,
        { headers: { 'Authorization': `Bearer ${localStorage.getItem('access_token')}` } })
        .then((response) => {
            dispatch({ type: types.CHECK_FAVORITE_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            dispatch({ type: types.CHECK_FAVORITE_ERROR, payload: null });
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                dispatch(loginActions.logout());
            } else {
                showNotification('Error', 'An error has occurred!', 'danger');
            }
        });
}

export const setTemplateCode = (value) => dispatch => {
    dispatch({
        type: types.SET_TEMPLATE_CODE,
        payload: value
    });
}

export const setQuantity = (value) => dispatch => {
    dispatch({
        type: types.SET_QUANTITY,
        payload: value
    });
}

export const setPrintingOption = (value) => dispatch => {
    dispatch({
        type: types.SET_PRINTING_OPTION,
        payload: value
    });
}

export const resetState = () => (dispatch) => {
    dispatch({
        type: types.RESET_STATE,
        payload: null,
    })
}

export const setLanguage = (value) => (dispatch) => {
    dispatch({
        type: types.SET_LANGUAGE,
        payload: value,
    })
}

export const setOrientation = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ORIENTATION,
        payload: value,
    })
}

export const setMaterialType = (value) => (dispatch) => {
    dispatch({
        type: types.SET_MATERIAL_TYPE,
        payload: value,
    })
}

export const setSize = (value) => (dispatch) => {
    dispatch({
        type: types.SET_SIZE,
        payload: value,
    })
}

export const setType = (value) => (dispatch) => {
    dispatch({
        type: types.SET_TYPE,
        payload: value,
    })
}

export const setAction = (value) => (dispatch) => {
    dispatch({
        type: types.SET_ACTION,
        payload: value,
    })
}